var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPindingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.38021 12.1136C7.26688 12.1136 7.16021 12.0936 7.04688 12.0536C6.68021 11.9136 6.44021 11.5736 6.44021 11.1802L6.44021 8.98024H5.78688C5.41355 8.98024 5.08688 8.76691 4.93355 8.43357C4.78021 8.09357 4.84021 7.71357 5.08688 7.43357L7.92688 4.20691C8.18688 3.91357 8.58688 3.81357 8.95355 3.95357C9.32021 4.09357 9.56021 4.43357 9.56021 4.82691V7.02691H10.2202C10.5935 7.02691 10.9202 7.24024 11.0735 7.57357C11.2269 7.91357 11.1669 8.29357 10.9202 8.57357L8.08021 11.8002C7.89355 12.0002 7.64021 12.1136 7.38021 12.1136ZM5.93355 7.98024L6.94021 7.98024C7.21355 7.98024 7.44021 8.20691 7.44021 8.48024L7.44021 11.0002L10.0669 8.02024H9.06021C8.78688 8.02024 8.56021 7.79357 8.56021 7.52024L8.56021 5.00024L5.93355 7.98024Z",
    fill: "#F9A000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.97917 15.1668C4.0325 15.1668 0.8125 11.9535 0.8125 8.00016C0.8125 4.04683 4.0325 0.833496 7.97917 0.833496C11.9258 0.833496 15.1458 4.04683 15.1458 8.00016C15.1458 11.9535 11.9325 15.1668 7.97917 15.1668ZM7.97917 1.8335C4.57917 1.8335 1.8125 4.60016 1.8125 8.00016C1.8125 11.4002 4.57917 14.1668 7.97917 14.1668C11.3792 14.1668 14.1458 11.4002 14.1458 8.00016C14.1458 4.60016 11.3792 1.8335 7.97917 1.8335Z",
    fill: "#F9A000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPindingIcon);
export default __webpack_public_path__ + "static/media/pinding-icon.b2b3b251bbd4a06735bc3e86169df545.svg";
export { ForwardRef as ReactComponent };